"use strict";
/****************************************************
 * Audit Information Platform Component
 * 下拉选项参照项目组件
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- iUAP ------
var tinper_bee_1 = require("tinper-bee");
//----- AIP ------
var RefItem_1 = require("./RefItem");
var Message_1 = require("./Message");
var Const_1 = require("./Const");
require("../style/RefItems.css");
var utils_1 = require("../utils");
var Option = tinper_bee_1.Select.Option;
/**
 * 下拉列表参照项组件
 *
 * 下拉列表组件，支持选择时间（年度，月份），是/否等情况
 *
 */
var SelectRef = /** @class */ (function (_super) {
    __extends(SelectRef, _super);
    function SelectRef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            values: [],
            value: [],
            defaultValue: _this.props.defaultValue,
        };
        /**
         * 设置默认值 ***override***
         * @function
         * @param {string} value
         */
        _this.setDefaultValue = function (value) {
            _this.setState({
                value: value,
            }, function () {
            });
        };
        /**
         * 远程请求数据 ***override***
         * 返回的数据必须是数组
         *
         * ~~~json
         * [{期间: "201601"},{期间: "201602"}, ... {期间: "201612"}]
         * ~~~
         * @function
         * @param {StringStringMap} params
         * @param {string} defaultValue
         */
        _this.loadData = function (params, defaultValue) {
            var _a;
            if (_this.props.options && _this.props.options.length > 0) {
                // 如果是直接显示的，就不load数据了
                var datas = _this.props.options;
                if (defaultValue) {
                    var originDefaultValue_1 = defaultValue; // copy value
                    if (defaultValue.startsWith("'")) {
                        defaultValue = defaultValue.substring(1, defaultValue.length - 1);
                    }
                    var matchs = datas.filter(function (item) {
                        return item[_this.props.valuefield] === defaultValue;
                    });
                    if (matchs.length > 0) {
                        _this.setState({
                            value: matchs[0][_this.props.valuefield],
                            values: datas,
                        }, function () {
                            _this.refItemValueChange(originDefaultValue_1);
                        });
                    }
                }
                else {
                    _this.setState({ values: datas }, function () {
                    });
                }
                return;
            }
            var getData = _this.props.loadData;
            var refId = _this.props.refId || "";
            var itemIndex = (_a = _this.props.itemIndex) !== null && _a !== void 0 ? _a : -1;
            getData(refId, itemIndex, _this.props.dsId, params)
                .then(function (resp) {
                var data = resp.data;
                if (!data) {
                    data = [];
                }
                // if (!this.props.must) {
                //     let item = {};
                //     item[this.props.valuefield] = '';
                //     item[this.props.displayfield] = '请选择';
                //     data.splice(0, 0, item);
                // }
                if (defaultValue) {
                    var originDefaultValue_2 = defaultValue; // copy value
                    var valueStrs_1 = [];
                    try {
                        valueStrs_1 = defaultValue.split(",");
                    }
                    catch (e) {
                        console.error(e.message);
                    }
                    valueStrs_1 = valueStrs_1.map(function (val) {
                        if (val.startsWith("'")) {
                            return val.substring(1, val.length - 1);
                        }
                        return val;
                    });
                    var matchs = data.filter(function (item) {
                        return valueStrs_1.includes(item[_this.props.valuefield]);
                    });
                    var vals = matchs.map(function (val) {
                        return val[_this.props.valuefield];
                    });
                    if (matchs.length > 0) {
                        _this.setState({
                            value: vals,
                            values: data,
                        }, function () {
                            _this.refItemValueChange(originDefaultValue_2);
                        });
                    }
                    else {
                        _this.setState({ values: data });
                    }
                }
                else {
                    _this.setState({ values: data });
                }
                setTimeout(function () {
                    _this.props.fetchCallback &&
                        _this.props.fetchCallback(data, params, refId, itemIndex);
                }, 200);
            })
                .catch(function (e) {
                if (!e.message) {
                    if (e !== "Error") {
                        Message_1.default.showMessage(Const_1.QUERY_ERROR_MSG, "danger", 5);
                    }
                }
                else {
                    Message_1.default.showMessage(e.message);
                }
                _this.refItemValueChange(null);
            });
        };
        /**
         * 判断给予的对象是否是Array类型
         * @function
         * @param {any} v
         * @returns {boolean}
         */
        _this._isArray = function (v) {
            return JSON.stringify(v).startsWith("[");
        };
        /**
         * 通过值反查该值对应的显示值(只返回第一个)
         * @function
         * @param {string} v
         * @returns {string}
         */
        _this._getSingleLabelFromValue = function (v) {
            for (var i = 0; i < _this.state.values.length; i++) {
                var item = _this.state.values[i];
                if (item[_this.props.valuefield] === v) {
                    return item[_this.props.displayfield];
                }
            }
            return "";
        };
        /**
         * 通过值反查该值对应的显示值
         * @function
         * @param {string[] | string} v
         * @returns {string}
         */
        _this._getLabelFromValue = function (v) {
            if (_this._isArray(v)) {
                var arr_1 = [];
                v.forEach(function (item, idx) {
                    arr_1.push(_this._getSingleLabelFromValue(item));
                });
                return arr_1.join(",");
            }
            else {
                return _this._getSingleLabelFromValue(v);
            }
        };
        /**
         * 选择项变化事件
         * @function
         * @param {string} v
         */
        _this._onChange = function (v) {
            if (!v || v === (0, utils_1.getTranslate)(null, Const_1.SELECT_DEFUALT_VALUE)) {
                _this.refItemValueChange(null);
                _this.setState({ value: v }, function () {
                });
            }
            else {
                _this.setState({ value: v }, function () {
                    _this.refItemValueChange(_this.getValue());
                });
            }
        };
        /**
         * 重置条件 ***override***
         * @function
         */
        _this.clear = function () {
            _this.setState({
                value: _this.props.multiple ? [] : "",
                defaultValue: _this.props.multiple ? [] : "",
                values: [],
            }, function () {
            });
        };
        return _this;
    }
    SelectRef.prototype.render = function () {
        var _this = this;
        var multiple = !(this.props.multiple === undefined || this.props.multiple === "0");
        return (React.createElement(tinper_bee_1.Select, { className: "selectref", style: { width: this.props.width || 200 }, noWarp: true, defaultValue: this.state.defaultValue, onChange: this._onChange, value: this.state.value, allowClear: !this.props.must, showSearch: true, optionFilterProp: "children", maxTagCount: 1, multiple: multiple }, this.state.values.map(function (item) {
            if (!(multiple &&
                item[_this.props.displayfield] ===
                    (0, utils_1.getTranslate)(null, Const_1.SELECT_DEFUALT_VALUE))) {
                return (React.createElement(Option, { key: item[_this.props.valuefield], value: item[_this.props.valuefield] }, item[_this.props.displayfield]));
            }
        })));
    };
    return SelectRef;
}(RefItem_1.default));
exports.default = SelectRef;
